import { toast } from "sonner";

export function printProfile(profile) {
  const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
  const stat = (label, value) => `<div class="stat"><div class="v">${esc(value)}</div><div class="l">${esc(label)}</div></div>`;
  const stats = [
    stat("Total Points", profile.total_points),
    stat("Event Wins", profile.wins),
    stat("Events Played", profile.events_played),
    stat("Best Finish", profile.best_finish ? `#${profile.best_finish}` : "—"),
  ].join("");
  const seasonRows = (profile.season_stats || []).map((s) => `<tr>
    <td>${esc(s.season)}</td>
    <td>${s.rank ? `#${s.rank} / ${s.total_players}` : "—"}</td>
    <td class="num">${s.points}</td>
    <td class="num">${s.events_played}</td>
    <td class="num">${s.wins}</td>
    <td class="num">${s.best_finish ? `#${s.best_finish}` : "—"}</td>
  </tr>`).join("");
  const resultRows = (profile.results || []).map((r) => `<tr>
    <td class="num">${r.place}</td>
    <td>${esc(r.event_title)}</td>
    <td>${esc(r.venue)}</td>
    <td>${esc(r.season)}</td>
    <td>${esc(r.date)}</td>
    <td class="num">${r.points}</td>
    <td class="num">${r.payout ? "$" + r.payout.toLocaleString() : "—"}</td>
  </tr>`).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(profile.name)} — Legends Poker</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Georgia, 'Times New Roman', serif; margin: 40px; color: #111; }
    .head { text-align:center; border-bottom: 3px solid #b8860b; padding-bottom: 16px; margin-bottom: 24px; }
    .brand { letter-spacing: 6px; text-transform: uppercase; font-size: 12px; color: #b8860b; font-family: Arial, sans-serif; }
    h1 { margin: 8px 0 4px; font-size: 30px; }
    h2 { font-size: 16px; margin: 26px 0 10px; font-family: Arial, sans-serif; text-transform: uppercase; letter-spacing: 1px; color:#b8860b; }
    .stats { display:flex; gap: 12px; margin: 8px 0 4px; }
    .stat { flex:1; border:1px solid #ddd; padding: 12px; text-align:center; }
    .stat .v { font-size: 24px; font-weight: bold; color:#b8860b; }
    .stat .l { font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color:#666; font-family: Arial, sans-serif; margin-top: 4px; }
    table { width: 100%; border-collapse: collapse; }
    th { text-align:left; font-family: Arial, sans-serif; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color:#b8860b; border-bottom: 2px solid #b8860b; padding: 8px 10px; }
    td { padding: 7px 10px; border-bottom: 1px solid #ddd; font-size: 13px; }
    td.num, th.num { text-align: right; }
    .foot { margin-top: 24px; text-align:center; color:#888; font-size: 11px; font-family: Arial, sans-serif; }
    @media print { body { margin: 12mm; } }
  </style></head><body>
    <div class="head"><div class="brand">Legends Poker League</div><h1>${esc(profile.name)}</h1></div>
    <div class="stats">${stats}</div>
    ${seasonRows ? `<h2>Season by Season</h2><table><thead><tr><th>Season</th><th>Rank</th><th class="num">Points</th><th class="num">Played</th><th class="num">Wins</th><th class="num">Best</th></tr></thead><tbody>${seasonRows}</tbody></table>` : ""}
    ${resultRows ? `<h2>Results History</h2><table><thead><tr><th class="num">Place</th><th>Event</th><th>Venue</th><th>Season</th><th>Date</th><th class="num">Points</th><th class="num">Payout</th></tr></thead><tbody>${resultRows}</tbody></table>` : ""}
    <div class="foot">Generated ${new Date().toLocaleDateString()}</div>
    <script>window.onload = function(){ window.print(); }</script>
  </body></html>`;
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  const w = window.open(url, "_blank");
  if (!w) { toast.error("Please allow pop-ups to print or save as PDF"); URL.revokeObjectURL(url); return false; }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}
